import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/authStore';
import { MessageThread } from '@/features/Messages/MessageThread';
import { useStudentThread, useSendMessage } from '@/lib/hooks/useMessages';

export const Route = createFileRoute('/messages/')({
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState();
    if (!isAuthenticated) throw redirect({ to: '/login' });
  },
  component: MessagesPage,
});

function MessagesPage() {
  const { data, isLoading } = useStudentThread();
  const send = useSendMessage(['messages', 'student']);

  return (
    <div className="mx-auto max-w-3xl p-6">
      <h1 className="font-heading text-2xl font-bold text-foreground">Messages</h1>
      <p className="mt-1 text-sm text-muted-foreground">Chat with your placement team.</p>
      <div className="mt-5 rounded-2xl border border-border bg-background p-4 shadow-sm">
        <MessageThread
          messages={data?.messages ?? []}
          self={data?.self ?? ''}
          loading={isLoading}
          sending={send.isPending}
          onSend={(body) => send.mutate({ body })}
          emptyText="No messages yet. Your placement team will reach out here."
        />
      </div>
    </div>
  );
}
